webpackJsonp([256061918750245],{

/***/ 386:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulProject":{"title":"Jumper","createdAt":"August 17th, 2018","images":[{"file":{"url":"//images.ctfassets.net/td17hthlq11b/2XlpStmFpSgOOoESCmM28W/f1bcec7bf62116a58cf88c66d5f95b4e/1-combined.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/77hnEDU4YoaCE0YcUKcauw/421aa8926a5e3d125f793174e5b1efc9/2-process.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/7D88ALFa9OqmQScgWCiWwi/551e1b4c6dbd3068fb3fedbd66792c5e/3-renderings.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/1UFX0FCP0YiGuKoOsuAkAS/3bb1a40f3a529d07af79e7580ff3c31e/4-photos.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/4v4T2Q0iPSEUAKsUGkce0O/f4c3456ce8c51d38cce5bda26982c902/5-photo.jpg"}}],"description":null}},"pathContext":{"slug":"jumper"}}

/***/ })

});


// WEBPACK FOOTER //
// path---project-jumper-28ae2677ca0d998fc1da.js